import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export type SpinnerMode = 'absolute' | 'fixed';

@Component({
    selector: 'se-spinner',
    templateUrl: './se-spinner.component.html',
    styleUrls: ['./se-spinner.component.scss'],
    standalone: true,
    imports: [NgIf, MatProgressSpinner],
})
export class SeSpinnerComponent {
    @Input()
    isBusy = false;
    @Input()
    mode: SpinnerMode = 'absolute';
    @Input()
    title: string;
    @Input()
    zIndex = 'initial';
    @Input()
    flexDirection = 'column';

    constructor(translate: TranslateService) {
        this.title = translate.instant('Loading');
    }
}
